export function getTrackRoute(id = ':trackId') {
    return `/track/${id}`;
}

export function getNodeRoute(trackId = ':trackId', nodeId = ':nodeId') {
    return `/track/${trackId}/${nodeId}`;
}
